import React from "react";

export const config = {
    api_key: "AIzaSyAhNos81dhalkd9Tzh1pzMdBdlgJSYc9zo",
    channel_id: "UCY-UUnbEsr_ZUKGy0q1Xj8A"
};